import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglepodcastsComponent } from './simple-icons-googlepodcasts.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglepodcastsComponent ],
    exports:      [ SimpleIconsGooglepodcastsComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglepodcastsModule {}
